import { playbackCatalog } from '../playback/catalog';

const isVideoKey = key => typeof key === 'string' && Object.prototype.hasOwnProperty.call(playbackCatalog, key);

export function isPlaybackMessage(message) {
    return message?.type === 'playback' && isVideoKey(message.video)
        && typeof message.paused === 'boolean'
        && Number.isFinite(message.time) && message.time >= 0
        && Number.isFinite(message.rate) && message.rate >= 0.25 && message.rate <= 4
        && (message.seek === undefined || typeof message.seek === 'boolean')
        && (message.next === null || isVideoKey(message.next));
}

export function synchronizeVideo(video, state, started, onBlocked) {
    if (video.dataset.scenario !== state.video) {
        video.dataset.scenario = state.video;
        // A buffered player may already have decoded this source in its spare slot.
        if (video.dataset.playbackUrl !== playbackCatalog[state.video]) {
            video.src = playbackCatalog[state.video];
            video.load();
        }
    }
    if (!started) {
        video.pause();
        return;
    }
    if (video.readyState < 1) return;
    const target = Number.isFinite(video.duration) ? Math.min(state.time, video.duration) : state.time;
    // Correct drift, while avoiding a seek on every heartbeat during playback.
    if (state.seek || Math.abs(video.currentTime - target) > (state.paused ? 0.1 : 0.8)) {
        video.currentTime = target;
    }
    video.playbackRate = state.rate;
    if (state.paused || (Number.isFinite(video.duration) && target >= video.duration)) video.pause();
    else if (video.paused) {
        video.play().catch(error => {
            if (error.name === 'NotAllowedError') onBlocked();
        });
    }
}
